import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SiaSessionApi {
  private api = inject(SiaHttpService);

  private readonly userInstanceController: string = 'user-instance-session';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  saveStorage(instanceId: string, storage: string): Promise<any> {
    return this.api.post(`${this.userInstanceController}`, {
      instanceIdentifier: instanceId,
      sessionData: storage,
    });
  }
  getStorage(instanceId: string) {
    return this.api.get(`${this.userInstanceController}/${instanceId}`);
  }
}
